<template>
  <div class="collection-panel">
    <PanelHeader title="マイ・コレクション">
      <template #icon>
        <Icon name="my-collection" size="md" color="blue-600" />
      </template>
      <template #actions>
        <div class="collection-panel__header-actions">
          <v-btn to="/collections" icon class="collection-panel__header-actions__button">
            <Icon name="next" size="xs" color="blue-600" />
          </v-btn>
        </div>
      </template>
    </PanelHeader>
    <div>
      <QuickAccessSection />
      <BinderSection :show-binder-list="auth.permissions.binder" />
    </div>
  </div>
</template>

<script setup lang="ts">
import BinderSection from '@/components/renewal/collection/binder-section.vue';
import QuickAccessSection from '@/components/renewal/collection/quick-access-section.vue';
import Icon from '@/components/renewal/common/icon.vue';
import PanelHeader from '@/components/renewal/common/panel-header.vue';
import { useAuth } from '@/plugins/auth';

const auth = useAuth();
</script>

<style src="./collection-panel.scss" lang="scss" scoped />
